import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppHeader from "@/components/_Header.vue";
import LoadingBetweenPages from "@/components/ModalComponent.vue";
import AppFooter from "@/components/_Footer.vue";
import { useRoute, useRouter } from "vue-router";
import { useHeaderAndFooter } from "@/stores/use-header-and-footer";
import { ref } from "vue";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();

const loadingBetweenPages = ref(null);

const headerAndFooter = useHeaderAndFooter();

function isLoginPage() {
  return useRoute().name === "login";
}

onMounted(() => {
  let shouldShowSpinner = false;
  router.beforeEach((to, from, next) => {
    shouldShowSpinner = true;

    /*
     * It should only show the route loading spinner
     * if the route takes some real time to load
     * */
    setTimeout(() => {
      if (!shouldShowSpinner) return;
      loadingBetweenPages.value.show();
    }, 200);
    next();
  });

  router.afterEach(() => {
    shouldShowSpinner = false;

    loadingBetweenPages.value.close();
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoadingBetweenPages, {
      ref_key: "loadingBetweenPages",
      ref: loadingBetweenPages
    }, null, 512),
    (_unref(headerAndFooter).getState().headerView && !isLoginPage())
      ? (_openBlock(), _createBlock(AppHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    (_unref(headerAndFooter).getState().footerView && !isLoginPage())
      ? (_openBlock(), _createBlock(AppFooter, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})